import { cn } from "@/lib/utils";
import React from "react";

function InputNumber({
  className,
  children,
  ...otherProps
}: Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">) {
  return (
    <input
      type="number"
      className={cn(
        "py-1.5 px-3 rounded-lg border border-gray-100 mt-2 w-full h-[46px] focus:outline-primary-400",
        className
      )}
      {...otherProps}
      onKeyDown={(e) => {
        if (["e", "E", ".", ",","-","+"].includes(e.key)) {
          e.preventDefault();
        }
      }}
    >
      {children}
    </input>
  );
}

export default InputNumber;
